import React, { useEffect, useState } from 'react';
import WidgetCarouselProps from '../widget-carousel.props';
import WidgetCarouselDesktopBasic from './components/widget-carousel-desktop-basic';
import SrcSet from '../../../../components/src-set/src-set';
import WidgetDSABadge from 'modules/shared/widgets/components/widget-dsa/components/widget-dsa-badge';
import { showDSA } from 'modules/shared/widgets/components/widget-dsa/helpers/dsa-helpers';
import getLinkRelByTarget from 'helpers/get-link-rel-by-target';

import './widget-carousel.desktop.scss';

const WidgetCarouselDesktop: React.FC<WidgetCarouselProps> = ({ config, data }) => {
    const [WidgetCarouselComponent, setWidgetCarousel] = useState<React.ComponentType<any>>(() => WidgetCarouselDesktopBasic);

    // autoPlay = false, imgHeight, itemsOnScreen, lazyLoad,
    useEffect(() => {
        import('react-multi-carousel').then(mod => {
            setWidgetCarousel(() => mod.default);
        });
    }, []);

    const responsive = {
        desktop: {
            breakpoint: { max: 5000, min: 0 },
            items: config.itemsOnScreen ?? 5
        }
    };

    return (
        <div className="w-carousel-d">
            <WidgetCarouselComponent
                responsive={responsive}
                swipeable={false}
                draggable={false}
                slidesToSlide={config.itemsOnScreen ?? 5}
                renderButtonGroupOutside={true}
                customButtonGroup={false}
                arrows={true}
                autoPlay={config.autoPlay}
                className="w-carousel-d__list"
                itemClass={`w-carousel-d__list__item w-${config.itemsOnScreen ?? 5} h-${config.itemsOnScreen ?? 5}`}
            >
                {
                    data.map((item, idx) => (
                        <a
                            rel={getLinkRelByTarget(item.target)}
                            href={item.url}
                            target={item.target}
                            className="w-carousel-d__list__item__content"
                            key={item.url}
                        >
                            {item?.dsa && showDSA(item.dsa) && (
                                <WidgetDSABadge dsa={item.dsa} />
                            )}
                            <div className="w-carousel-d__list__item__content__image">
                                <SrcSet
                                    images={item.modifiedImg}
                                    alt={item.title.trim() || `Obrazek ${idx}`}
                                    lazyLoad={config.lazyLoad}
                                />
                            </div>
                        </a>
                    ))
                }
            </WidgetCarouselComponent>
        </div>
    );
};

export default WidgetCarouselDesktop;
